export const STATES_COMPROBANTE = [
    "PENDIENTE",
    "AUTORIZADO",
    "RECHAZADO"
];

export const ifState = (state, canModifyRechazado = false) => {
    switch (state) {
        case "PENDIENTE":
            return ["AUTORIZADO", "RECHAZADO"];
        case "AUTORIZADO":
            return ["PENDIENTE", "RECHAZADO"];
        case "RECHAZADO":
            return canModifyRechazado ? ["PENDIENTE"] : [];

        default: return [];

    }
}

export const STATES_SOLICITUD = [
    "PENDIENTE",
    "CERRADA",
];

export const ifStateSolicitud = (state) => {
    switch (state) {
        case "PENDIENTE":
            return ["CERRADA"];
        case "CERRADA":
            return [];
       
        default: return [];

    }
}